import { EffectFade, Autoplay, Navigation, Pagination, A11y, Grid, Mousewheel, EffectCoverflow } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

export function useSwiper() {
  const SLIDERS_PER_VIEW = {
    EXTRA_TINY: 1.2,
    TINY: 1.4,
    EXTRA_EXTRA_SMALL: 1.6,
    EXTRA_SMALL: 2,
    SMALL: 2.5,
    NORMAL: 3,
    MEDIUM: 3.5,
    LARGE: 4,
    XLARGE: 5
  }
  const SPACE_BETWEEN_SWIPER = {
    NONE: 0,
    SMALL: 8,
    MEDIUM: 15,
    LARGE: 16,
    XLARGE: 24
  }
  return {
    modules: [EffectFade, Autoplay, Navigation, Pagination, A11y, Grid, Mousewheel, EffectCoverflow],
    Swiper,
    SwiperSlide,
    SLIDERS_PER_VIEW,
    SPACE_BETWEEN_SWIPER
  }
}
